import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import trendingApi from '../../api/trendingApi';
import { LinkSource } from '../../constants/link-source';
import resolveBuyLink, { NO_AFF_LINK_MESSAGE } from '../../utils/resolve-buy-link';
import SavedProductCard from './saved-product-card';

/** Tab "Đã xem gần đây" — dùng API my-activity */
function RecentlyViewedTab() {
    const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetch = async () => {
            try {
                const res = await trendingApi.getMyActivity();
                setProducts(res.data?.data?.products || res.data?.data || []);
            } catch (err) {
                console.warn('[RecentlyViewed] fetch error:', err);
            } finally {
                setIsLoading(false);
            }
        };
        fetch();
    }, []);

    const handleBuy = async (product) => {
        try {
            const { url, followUpUrl } = await resolveBuyLink({
                platform: product.platform,
                productLink: product.productLink,
                productId: product.productId,
                meta: {
                    productId: product.productId,
                    productName: product.productName,
                    productImage: product.productImage,
                    productPrice: product.productPrice,
                    shopName: product.shopName,
                    commission: product.commission,
                },
            }, LinkSource.RecentlyViewed);
            window.location.href = url;
            if (followUpUrl) setTimeout(() => { window.location.href = followUpUrl; }, 2500);
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || NO_AFF_LINK_MESSAGE);
        }
    };

    if (isLoading) {
        return (
            <div className="flex flex-col gap-3 p-3">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="bg-surface rounded-lg h-28 animate-pulse" />
                ))}
            </div>
        );
    }

    if (products.length === 0) {
        return (
            <div className="text-center py-12 text-content-3 text-sm px-6">
                Chưa có sản phẩm nào được xem gần đây
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2 p-3">
            {products.map((product) => (
                <SavedProductCard
                    key={`recent-${product.productId}`}
                    product={product}
                    onBuy={handleBuy}
                />
            ))}
        </div>
    );
}

export default RecentlyViewedTab;
